import { render, staticRenderFns } from "./ProgramOverview.vue?vue&type=template&id=6fa91b5a&scoped=true&"
import script from "./ProgramOverview.vue?vue&type=script&lang=js&"
export * from "./ProgramOverview.vue?vue&type=script&lang=js&"
import style0 from "./ProgramOverview.vue?vue&type=style&index=0&id=6fa91b5a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa91b5a",
  null
  
)

export default component.exports